module.exports = __webpack_public_path__ + "static/media/nano.6eedd591.svg";